import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setScreen } from "../redux/actions";
import Header from "./header";
import Sidebar from "./sidebar";
import CommonDrawer from "../components/global/drawer";

const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const [sidebarIsOpen, setSidebarOpen] = useState(isDesktop ? true : false);

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 1024;
      setIsDesktop(desktop);
      dispatch(setScreen(!desktop));
    };

    window.addEventListener("resize", handleResize);
    // Initial call
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  const toggleSidebar = (isMainToggleBtn = false) => {
    if (isDesktop && isMainToggleBtn !== true) return;
    setSidebarOpen(!sidebarIsOpen);
  };

  return (
    <div
      className="d-flex flex-row-reverse"
      style={{
        backgroundColor: "#f3f3f3",
        overflowX: "hidden",
        minHeight: "100vh"
      }}
    >
      <Header
        children={children}
        sidebarIsOpen={sidebarIsOpen}
        toggleSidebar={toggleSidebar}
      />

      {isDesktop ? (
        <Sidebar toggle={toggleSidebar} isOpen={sidebarIsOpen} />
      ) : (
        <CommonDrawer
          open={sidebarIsOpen}
          setOpen={setSidebarOpen}
          width={"380px"}
          placement="left"
        >
          <Sidebar toggle={toggleSidebar} isOpen={true} isMobile={true} />
        </CommonDrawer>
      )}
    </div>
  );
};

export default Layout;
